/**
 * Unimod access control — mirrors va-portal's own gate
 * (src/utils/navbar/unimodAccess.js), which this menu is the counterpart of.
 *
 * Backend-controlled via `hasAdminPanelAccess` on userInfo (the getUserInfoV2 response),
 * so it's available any time userInfo is loaded, not just at va-portal's login moment.
 */
export function isUnimodAccessAllowed(userInfo) {
  return !!userInfo?.hasAdminPanelAccess;
}
